export const filterByStatus = (
    items: any[],
    status: string,
    statusKey: string = 'status'
  ): any[] => {
    if (!Array.isArray(items)) return [];
  
    return items.filter(item =>
      item[statusKey]?.toLowerCase() === status.toLowerCase()
    );
  };
  